import { useMemo, useSyncExternalStore } from "react";
import type {
	FreeArea,
	OrientationType,
	PlatformType,
} from "@rubyplay/effw-connector";
import { getHostSessionStore } from "@/host/HostSessionStore";
import type { HostSessionSnapshot } from "@/host/HostSessionTypes";

export type HostLayoutSnapshot = {
	freeAreas: readonly Readonly<FreeArea>[];
	platform: PlatformType;
	orientation: OrientationType;
};

function toPlatform(value: unknown): PlatformType {
	return value === "mobile" ? "mobile" : "desktop";
}

function toOrientation(value: unknown): OrientationType {
	return value === "portrait" ? "portrait" : "landscape";
}

function buildHostLayoutSnapshot(
	snapshot: HostSessionSnapshot
): HostLayoutSnapshot {
	return {
		freeAreas: snapshot.freeAreas,
		platform: toPlatform(snapshot.config?.platform),
		orientation: toOrientation(snapshot.config?.orientation),
	};
}

export function useHostLayout(): HostLayoutSnapshot {
	const store = getHostSessionStore();

	const snapshot = useSyncExternalStore(
		(onStoreChange) => store.subscribe(() => onStoreChange()),
		() => store.getSnapshot(),
		() => store.getSnapshot()
	);

	return useMemo(
		() => buildHostLayoutSnapshot(snapshot),
		[snapshot]
	);
}

export default useHostLayout;
